export const START_DRIVERS_LINK_GAME_COMPLETED = "driversLink/startGameCompleted";
export const GUESS_DRIVER_COMPLETED = "driversLink/guessDriverCompleted";
export const GET_DRIVERS_LINK_STATUS_COMPLETED = "driversLink/getGameStatusCompleted";
export const GET_DRIVER_SUGGESTIONS_COMPLETED = "driversLink/getDriverSuggestionsCompleted";
export const CLEAR_DRIVER_SUGGESTIONS = "driversLink/clearDriverSuggestions";
